import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatInputModule } from '@angular/material/input'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromChannels from './store/channels.reducer'
import { ChannelsEffects } from './store/channels.effects'
import { ChannelsService } from './store/channels.service'
import { Tv3PlatformModule } from '@tokeet/tv3-platform'
import { HomeToGoConnectionFormComponent } from './components/hometogo-connection-form/hometogo-connection-form.component'
import { FeedChannelConfigComponent } from './components/feed/channel/feed-channel-config/feed-channel-config.component'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatTooltipModule } from '@angular/material/tooltip'
import { FeedChannelDetailsComponent } from './components/feed/channel/feed-channel-details/feed-channel-details.component'
import { MatTableModule } from '@angular/material/table'
import { MatSortModule } from '@angular/material/sort'
import { MatPaginatorModule } from '@angular/material/paginator'
import { HomeToGoChannelGuard } from './guards/hometogo-channel.guard'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { FeedConnectionDetailsComponent } from './components/feed/connection/feed-connection-details/feed-connection-details.component'
import { FeedConnectionConfigComponent } from './components/feed/connection/feed-connection-config/feed-connection-config.component'
import { HomeToGoChannelConfigForm } from './components/feed/config/feed-config/hometogo-channel-config-form.component'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { EditRentalTaxesModule, RentalFeesModule, RentalTaxesModule } from '@tokeet-frontend/rentals'
import { PermissionModule } from '@tokeet-frontend/permission'
import { RentalsUnitedChannelEffects } from './store/rentals-united/effects'
import { HoliduChannelEffects } from './store/holidu/effects'
import { HVMIChannelEffects } from './store/hvmi/effects'
import { TiketChannelEffects } from './store/tiket/effects'
import { GVRChannelEffects } from './store/gvr/effects'
import { CtripChannelEffects } from './store/ctrip/effects'
import { RatingComponent } from './components/rating/rating.component'
import { UtilityLibraryModule } from '@tokeet-frontend/utility'

const components = [
  HomeToGoConnectionFormComponent,
  FeedChannelConfigComponent,
  FeedChannelDetailsComponent,
  FeedConnectionDetailsComponent,
  FeedConnectionConfigComponent,
  HomeToGoChannelConfigForm,
  RatingComponent,
]

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatInputModule,
    StoreModule.forFeature('channels-lib', fromChannels.channelsReducer),
    EffectsModule.forFeature([
      ChannelsEffects,
      RentalsUnitedChannelEffects,
      HVMIChannelEffects,
      HoliduChannelEffects,
      TiketChannelEffects,
      GVRChannelEffects,
      CtripChannelEffects,
    ]),
    Tv3PlatformModule,
    MatRadioModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    BsDropdownModule,
    RentalTaxesModule,
    RentalFeesModule,
    EditRentalTaxesModule,
    PermissionModule,
    UtilityLibraryModule,
  ],
  providers: [HomeToGoChannelGuard],
  declarations: [...components],
  exports: [...components],
})
export class ChannelsLibraryModule {}
